import { cn } from '@/lib/utils'

import { HitchhikersMark } from './HitchhikersMark'

export type WalletMarkState = 'disconnected' | 'connected' | 'wrong-network'

const markColors: Record<WalletMarkState, string> = {
  disconnected: 'text-muted-foreground',
  connected: 'text-primary',
  'wrong-network': 'text-destructive',
}

/** Fondo del patch informativo de estado. */
export function walletStatusZoneTone(state: WalletMarkState): string {
  if (state === 'wrong-network') return 'bg-destructive/10'
  if (state === 'connected') return 'bg-primary/10'
  return 'bg-muted/40'
}

/** Hover del patch informativo clicable. */
export function walletStatusZoneHover(state: WalletMarkState): string {
  if (state === 'wrong-network') return 'hover:bg-destructive/15'
  if (state === 'connected') return 'hover:bg-primary/15'
  return 'hover:bg-muted/55'
}

/** Celda cuadrada del icono (misma altura que el bloque de sesión: 2.5rem). */
export const walletMarkBaySize = 'size-10'

interface WalletMarkIconProps {
  state: WalletMarkState
  className?: string
}

/** Marca SVG teñida por estado, centrada por la celda padre. */
export function WalletMarkIcon({ state, className }: WalletMarkIconProps) {
  return (
    <HitchhikersMark
      className={cn('max-h-full max-w-full', markColors[state], className)}
    />
  )
}
